import React from 'react';
import PropTypes from 'prop-types';

const Name = ({ user:{name} }) => (
	name ? <span>{name}</span>
		: <span><i>Unknown</i></span>
)

Name.propTypes = {
	user: PropTypes.object.isRequired
}

export default Name;